import React from "react"
import Typist from "react-typist"
import styled from "styled-components"
import Container from "./forLayout/container"

const QuoteWrapper = styled.div`
  color: #fff;
  margin: 0 auto;
  text-align: center;
  font-family: "GFS Didot", serif;
  @media screen and (min-width: 768px) {
    flex: 0 0 50%;
    max-width: 50%;
  }
`
const Section = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media screen and (min-width: 768px) {
    margin-top: 2rem;
  }
`
const SectionCategory = styled.p`
  color: #999;
`

const SectionTitle = styled.h2`
  font-family: "GFS Didot", serif;
  font-size: 4rem;
  line-height: 4rem;
  margin-bottom: 2rem;
`

const SectionParagraph = styled.p`
  font-family: "GFS Didot", serif;
  font-size: 1.4rem;
  line-height: 2.5rem;
  color: #dedede;
  a {
    text-decoration: underline;
    color: #fff;
  }
  a:hover {
    color: #fff;
  }
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  > * {
    padding: 0 0.1rem;
  }
  @media screen and (min-width: 768px) {
    flex-direction: row;
    > * {
      padding: 0 2rem;
    }
  }
`

const ThirdSection = () => {
  return (
    <Container>
      <Wrapper>
        <QuoteWrapper>
          <h1>"</h1>
          <Typist className="quote">
            Each person who told me I couldn't will be one more time I raise
            that trophy.
            <Typist.Backspace count={80} delay={200} />
            I'm not going to stop running until the fastest person alive is a
            woman.
          </Typist>
          <h1>"</h1>
        </QuoteWrapper>
        <Section>
          <SectionCategory>Join Us</SectionCategory>
          <SectionTitle>Make a new commitment to your crazy dream</SectionTitle>
          <SectionParagraph>
            Tell us the motivation behind your crazy dream, and join a community
            of crazy dreamers just like you. For a limited time, you’ll also
            have the chance to get our Crazy Dreamer Necklace—available at
            select Nike Stores.{" "}
            <a
              href="https://nike.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn More
            </a>
          </SectionParagraph>
          <SectionParagraph>
            Log-in or create a NikePlus member account to get started.
          </SectionParagraph>
        </Section>
      </Wrapper>
    </Container>
  )
}

export default ThirdSection
